import { useFctPreviousStudies } from './use-fct-previous-studies.hook';

export function usePreviousStudies() {
  return useFctPreviousStudies();
}
